import { render, staticRenderFns } from "./ViewPostingPrint.vue?vue&type=template&id=703f8ea6&scoped=true&"
import script from "./ViewPostingPrint.vue?vue&type=script&lang=js&"
export * from "./ViewPostingPrint.vue?vue&type=script&lang=js&"
import style0 from "./ViewPostingPrint.vue?vue&type=style&index=0&id=703f8ea6&scoped=true&lang=css&"
import style1 from "./ViewPostingPrint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703f8ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VImg,VRow,VSimpleTable})
